export default __webpack_public_path__ + "static/thumb-audio1-f3e5c4a29da1de770759e30dbec34d61.png";